import * as THREE from "three";

var Utilities = {
    // returns an array of the numbers up to setsize that aren't in subset
    setComplement: function (setsize, subset) {
        var complementmask = Array.apply(null, Array(setsize)).map(Boolean.prototype.valueOf, true);
        for (var i = 0; i < subset.length; ++i) {
            complementmask[subset[i]] = false;
        }

        var complement = [];
        for (var i = 0; i < setsize; ++i) {
            if (complementmask[i]) complement.push(i);
        }

        return complement;
    },

    smoothStep: function (x, edge1, edge2) {
        var y = Math.max(Math.min((x - edge1)/(edge2 - edge1), 1.0), 0.0);

        return y*y*(3 - 2*y);
    },

    THREE: {
        getEdgeFaces: function (geometry, faceset) {
            if (!faceset) {
                faceset = [];
                for (var i = 0; i < geometry.faces.length; ++i) faceset.push(i);
            }

            var edgefaces = [];

            for (var i = 0; i < faceset.length; ++i) {
                var face = geometry.faces[faceset[i]];

                if (edgefaces[face.a] === undefined) edgefaces[face.a] = [];
                if (edgefaces[face.b] === undefined) edgefaces[face.b] = [];
                if (edgefaces[face.c] === undefined) edgefaces[face.c] = [];

                if  (edgefaces[face.a][face.b] === undefined) edgefaces[face.a][face.b] = [ faceset[i] ];
                else edgefaces[face.a][face.b].push(faceset[i]);

                if  (edgefaces[face.a][face.c] === undefined) edgefaces[face.a][face.c] = [ faceset[i] ];
                else edgefaces[face.a][face.c].push(faceset[i]);

                if  (edgefaces[face.b][face.a] === undefined) edgefaces[face.b][face.a] = [ faceset[i] ];
                else edgefaces[face.b][face.a].push(faceset[i]);

                if  (edgefaces[face.b][face.c] === undefined) edgefaces[face.b][face.c] = [ faceset[i] ];
                else edgefaces[face.b][face.c].push(faceset[i]);

                if  (edgefaces[face.c][face.a] === undefined) edgefaces[face.c][face.a] = [ faceset[i] ];
                else edgefaces[face.c][face.a].push(faceset[i]);

                if  (edgefaces[face.c][face.b] === undefined) edgefaces[face.c][face.b] = [ faceset[i] ];
                else edgefaces[face.c][face.b].push(faceset[i]);
            }

            return edgefaces;

        },

        countEdgeFaces: function (geometry, faceset) {
            if (!faceset) {
                faceset = [];
                for (var i = 0; i < geometry.faces.length; ++i) faceset.push(i);
            }

            var edgefacecount = [];

            for (var i = 0; i < faceset.length; ++i) {
                var face = geometry.faces[faceset[i]];

                if (edgefacecount[face.a] === undefined) edgefacecount[face.a] = [];
                if (edgefacecount[face.b] === undefined) edgefacecount[face.b] = [];
                if (edgefacecount[face.c] === undefined) edgefacecount[face.c] = [];

                if  (edgefacecount[face.a][face.b] === undefined) edgefacecount[face.a][face.b] = 1;
                else edgefacecount[face.a][face.b] += 1;

                if  (edgefacecount[face.a][face.c] === undefined) edgefacecount[face.a][face.c] = 1;
                else edgefacecount[face.a][face.c] += 1;

                if  (edgefacecount[face.b][face.a] === undefined) edgefacecount[face.b][face.a] = 1;
                else edgefacecount[face.b][face.a] += 1;

                if  (edgefacecount[face.b][face.c] === undefined) edgefacecount[face.b][face.c] = 1;
                else edgefacecount[face.b][face.c] += 1;

                if  (edgefacecount[face.c][face.a] === undefined) edgefacecount[face.c][face.a] = 1;
                else edgefacecount[face.c][face.a] += 1;

                if  (edgefacecount[face.c][face.b] === undefined) edgefacecount[face.c][face.b] = 1;
                else edgefacecount[face.c][face.b] += 1;
            }

            return edgefacecount;
        },

        subdivideAndAddRandom: function (geometry, range, faceset, curve) {
            var newgeometry = new THREE.Geometry();

            if (!faceset) {
                faceset = [];
                for (var i = 0; i < geometry.faces.length; ++i) faceset.push(i);
            } else {
                var antifaceset = Utilities.setComplement(geometry.faces.length, faceset);
            }

            if (geometry.subdivided || antifaceset) newgeometry.subdivided = [];

            curve = curve === undefined ? true : curve;
    
            var edgeverts = [];
            var vertdups = [];
    
            if (antifaceset || geometry.seamNormals) {
                var fsedgefaces = this.getEdgeFaces(geometry, faceset);
                var seamNormals = [];
            }

            var initialLength = faceset.length;
            for (var i = 0; i < initialLength; ++i) {
                var f = geometry.faces[faceset[i]];

                var ia = f.a;
                var ib = f.b;
                var ic = f.c;
    
                var color = f.color;
    
                var a = geometry.vertices[ia];
                var b = geometry.vertices[ib];
                var c = geometry.vertices[ic];
    
                var a_length = a.length();
                var b_length = b.length();
                var c_length = c.length();
    
                var ia_new, ib_new, ic_new;
    
                if (vertdups[ia] == undefined) {
                    ia_new = newgeometry.vertices.push(a.clone())-1;
                    vertdups[ia] = ia_new;
                } else {
                    ia_new = vertdups[ia];
                }
    
                if (vertdups[ib] == undefined) {
                    ib_new = newgeometry.vertices.push(b.clone())-1;
                    vertdups[ib] = ib_new;
                } else {
                    ib_new = vertdups[ib];
                }
    
                if (vertdups[ic] == undefined) {
                    ic_new = newgeometry.vertices.push(c.clone())-1;
                    vertdups[ic] = ic_new;
                } else {
                    ic_new = vertdups[ic];
                }
    
                var ab, bc, ca, iab, ibc, ica;
    
                if (edgeverts[ia] == undefined) edgeverts[ia] = [];
                if (edgeverts[ib] == undefined) edgeverts[ib] = [];
                if (edgeverts[ic] == undefined) edgeverts[ic] = [];
    
                if (edgeverts[ia][ib] == undefined) {
                    ab = (new THREE.Vector3()).copy(a).add(b);
                    if (!seamNormals || fsedgefaces[ia][ib].length > 1) {
                        ab.normalize().multiplyScalar((a_length+b_length)/2);
                        ab.addScaledVector(ab, (Math.random()-(antifaceset ? 0 : 0.5))*range/ab.length());
                    } else {
                        //if (color == f.color) color = new THREE.Color(0xff0000);
                        ab.divideScalar(2);
                    }

                    iab = newgeometry.vertices.push(ab)-1;

                    edgeverts[ia][ib] = iab;
                    edgeverts[ib][ia] = iab;

                    if (seamNormals && fsedgefaces[ia][ib].length == 1) {
                        var aNormal = f.vertexNormals[0],
                            bNormal = f.vertexNormals[1];

                        if (geometry.seamNormals) {
                            if (geometry.seamNormals[ia]) {
                                aNormal = geometry.seamNormals[ia];
                            }

                            if (geometry.seamNormals[ib]) {
                                bNormal = geometry.seamNormals[ib];
                            }
                        }

                        seamNormals[iab] = aNormal.clone().add(bNormal).divideScalar(2);
                    }

                } else {
                    iab = edgeverts[ia][ib];
                    ab = newgeometry.vertices[iab];
                }
    
                if (edgeverts[ib][ic] == undefined) {
                    bc = (new THREE.Vector3()).copy(b).add(c);
                    if (!seamNormals || fsedgefaces[ib][ic].length > 1) {
                        bc.normalize().multiplyScalar((b_length+c_length)/2);
                        bc.addScaledVector(bc, (Math.random()-(antifaceset ? 0 : 0.5))*range/bc.length());
                    } else {
                        //if (color == f.color) color = new THREE.Color(0xff0000);
                        bc.divideScalar(2);
                    }

                    ibc = newgeometry.vertices.push(bc)-1;

                    edgeverts[ib][ic] = ibc;
                    edgeverts[ic][ib] = ibc;

                    if (seamNormals && fsedgefaces[ib][ic].length == 1) {
                        var bNormal = f.vertexNormals[1],
                            cNormal = f.vertexNormals[2];

                        if (geometry.seamNormals) {
                            if (geometry.seamNormals[ib]) {
                                bNormal = geometry.seamNormals[ib];
                            }

                            if (geometry.seamNormals[ic]) {
                                cNormal = geometry.seamNormals[ic];
                            }
                        }
                        
                        seamNormals[ibc] = bNormal.clone().add(cNormal).divideScalar(2);
                    }

                } else {
                    ibc = edgeverts[ib][ic];
                    bc = newgeometry.vertices[ibc];
                }
    
                if (edgeverts[ic][ia] == undefined) {
                    ca = (new THREE.Vector3()).copy(c).add(a);
                    if (!seamNormals || fsedgefaces[ic][ia].length > 1) {
                        ca.normalize().multiplyScalar((c_length+a_length)/2);
                        ca.addScaledVector(ca, (Math.random()-(antifaceset ? 0 : 0.5))*range/ca.length());
                    } else {
                        //if (color == f.color) color = new THREE.Color(0xff0000);
                        ca.divideScalar(2);
                    }

                    ica = newgeometry.vertices.push(ca)-1;

                    edgeverts[ic][ia] = ica;
                    edgeverts[ia][ic] = ica;

                    if (seamNormals && fsedgefaces[ic][ia].length == 1) {
                        var cNormal = f.vertexNormals[2],
                            aNormal = f.vertexNormals[0];

                        if (geometry.seamNormals) {
                            if (geometry.seamNormals[ic]) {
                                cNormal = geometry.seamNormals[ic];
                            }

                            if (geometry.seamNormals[ia]) {
                                aNormal = geometry.seamNormals[ia];
                            }
                        }
                        
                        seamNormals[ica] = cNormal.clone().add(aNormal).divideScalar(2);
                    }

                } else {
                    ica = edgeverts[ic][ia];
                    ca = newgeometry.vertices[ica];
                }
    
                var f1 = newgeometry.faces.push(new THREE.Face3(ia_new, iab, ica, f.normal, color, f.materialIndex))-1;
                var f2 = newgeometry.faces.push(new THREE.Face3(ib_new, ibc, iab, f.normal, color, f.materialIndex))-1;
                var f3 = newgeometry.faces.push(new THREE.Face3(ic_new, ica, ibc, f.normal, color, f.materialIndex))-1;
                var f4 = newgeometry.faces.push(new THREE.Face3(iab, ibc, ica, f.normal, color, f.materialIndex))-1;

                if (antifaceset || (geometry.subdivided && geometry.subdivided[faceset[i]])) {
                    newgeometry.subdivided[f1] = true;
                    newgeometry.subdivided[f2] = true;
                    newgeometry.subdivided[f3] = true;
                    newgeometry.subdivided[f4] = true;
                }
            }
    
            if (antifaceset) {
                // Add unmodified faces to new geometry
                for (var i = 0; i < antifaceset.length; ++i) {
                    var f = geometry.faces[antifaceset[i]];
    
                    var ia_new, ib_new, ic_new;
    
                    if (vertdups[f.a] == undefined) {
                        ia_new = newgeometry.vertices.push(geometry.vertices[f.a].clone())-1;
                        vertdups[f.a] = ia_new;
                    } else {
                        ia_new = vertdups[f.a];
                    }
    
                    if (vertdups[f.b] == undefined) {
                        ib_new = newgeometry.vertices.push(geometry.vertices[f.b].clone())-1;
                        vertdups[f.b] = ib_new;
                    } else {
                        ib_new = vertdups[f.b];
                    }
    
                    if (vertdups[f.c] == undefined) {
                        ic_new = newgeometry.vertices.push(geometry.vertices[f.c].clone())-1;
                        vertdups[f.c] = ic_new;
                    } else {
                        ic_new = vertdups[f.c];
                    }
    
                    var n = newgeometry.faces.push(new THREE.Face3(ia_new, ib_new, ic_new, f.normal, f.color, f.materialIndex))-1;

                    if (geometry.subdivided && geometry.subdivided[antifaceset[i]]) newgeometry.subdivided[n] = true;
                }
            }
    
            newgeometry.computeVertexNormals();

            if (seamNormals) {
                newgeometry.seamNormals = seamNormals;

                if (geometry.seamNormals) {
                    for (var i = 0; i < geometry.vertices.length; ++i) {
                        if (geometry.seamNormals[i]) {
                            newgeometry.seamNormals[vertdups[i]] = geometry.seamNormals[i];
                        }
                    }
                }

                for (var i = 0; i < newgeometry.faces.length; ++i) {
                    var f = newgeometry.faces[i];

                    var asn = newgeometry.seamNormals[f.a];
                    var bsn = newgeometry.seamNormals[f.b];
                    var csn = newgeometry.seamNormals[f.c];

                    if (asn) f.vertexNormals[0].copy(asn);
                    if (bsn) f.vertexNormals[1].copy(bsn);
                    if (csn) f.vertexNormals[2].copy(csn);
                }
            }

            return newgeometry;
        }
    }
};

export default Utilities;
